module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-rank_1.png?v=701e9ffa";